import { ImagesLocalization } from './types';
import logo_black from '../assets/logo_black.png';
import logo_white from '../assets/logo_white.png';

const images: ImagesLocalization = {
  logo_black: {
    DE: logo_black,
    CH: logo_black,
  },
  logo_white: {
    DE: logo_white,
    CH: logo_white,
  },
};

export default images;
